import { createTheme } from '@mui/material'
import components from './components'
import breakpoints from './breakpoints'
import palette from './palette'
import typography from './typography'

const theme = createTheme({
  breakpoints,
  palette,
  typography,
  components
})

export default theme
